import React from 'react';

function EmpresaCamposForm({ form, setForm, logoPreview, fileInputRef, onFileChange, mostrarAtivo }) {
  const atualizarTelefone = (idx, valor) => {
    const novos = [...form.telefones];
    novos[idx] = valor;
    setForm({ ...form, telefones: novos });
  };

  const removerTelefone = (idx) => {
    setForm({ ...form, telefones: form.telefones.filter((_, i) => i !== idx) });
  };

  const adicionarTelefone = () => {
    setForm({ ...form, telefones: [...form.telefones, ''] });
  };

  return (
    <>
      <div className="cfg-row">
        <div className="cfg-field">
          <label className="cfg-label">Nome *</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="Nome da empresa"
            value={form.nome}
            onChange={(e) => setForm({ ...form, nome: e.target.value })}
            required
          />
        </div>
        <div className="cfg-field">
          <label className="cfg-label">Nome Fantasia</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="Nome fantasia"
            value={form.nome_fantasia}
            onChange={(e) => setForm({ ...form, nome_fantasia: e.target.value })}
          />
        </div>
      </div>

      <div className="cfg-row">
        <div className="cfg-field">
          <label className="cfg-label">Razão Social</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="Razão social completa"
            value={form.razao_social}
            onChange={(e) => setForm({ ...form, razao_social: e.target.value })}
          />
        </div>
        <div className="cfg-field">
          <label className="cfg-label">CNPJ</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="00.000.000/0000-00"
            value={form.cnpj}
            onChange={(e) => setForm({ ...form, cnpj: e.target.value })}
          />
        </div>
      </div>

      <div className="cfg-row">
        <div className="cfg-field">
          <label className="cfg-label">Inscrição Estadual (IE)</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="IE"
            value={form.ie}
            onChange={(e) => setForm({ ...form, ie: e.target.value })}
          />
        </div>
        <div className="cfg-field">
          <label className="cfg-label">Inscrição Municipal (IM)</label>
          <input
            className="cfg-input"
            type="text"
            placeholder="IM"
            value={form.im}
            onChange={(e) => setForm({ ...form, im: e.target.value })}
          />
        </div>
      </div>

      <div className="cfg-field">
        <label className="cfg-label">Telefone(s)</label>
        {form.telefones.map((tel, idx) => (
          <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <input
              className="cfg-input"
              type="text"
              placeholder="(00) 00000-0000"
              value={tel}
              onChange={(e) => atualizarTelefone(idx, e.target.value)}
              style={{ flex: 1 }}
            />
            <button
              type="button"
              className="prd-icon-btn prd-icon-btn--danger"
              onClick={() => removerTelefone(idx)}
              title="Remover telefone"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
        ))}
        <button type="button" className="cfg-btn-secondary" onClick={adicionarTelefone}>
          <span className="material-symbols-outlined">add</span>
          Adicionar telefone
        </button>
      </div>

      {mostrarAtivo && (
        <div className="cfg-field cfg-field--checkboxes">
          <label className="cfg-label">Status</label>
          <label className="cfg-checkbox-label">
            <input
              type="checkbox"
              checked={form.ativo}
              onChange={(e) => setForm({ ...form, ativo: e.target.checked })}
            />
            Empresa ativa
          </label>
        </div>
      )}

      <div className="cfg-field">
        <label className="cfg-label">Logo da Empresa</label>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={onFileChange}
        />
        <div
          className="prd-upload-area"
          onClick={() => fileInputRef.current.click()}
          style={{ cursor: 'pointer', overflow: 'hidden', width: 160, height: 160 }}
        >
          {logoPreview ? (
            <img
              src={logoPreview}
              alt="Preview do logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '8px' }}
            />
          ) : (
            <>
              <span className="material-symbols-outlined prd-upload-icon">upload_file</span>
              <p className="prd-upload-label">Enviar logo</p>
              <p className="prd-upload-sub">PNG, JPG (máx. 5MB)</p>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default EmpresaCamposForm;
